import { lazy } from "react";

import type { FragmentType } from "~/utils/fragment";

import type { TextDefinition_DefinitionFragment } from "./TextDefinition_DefinitionFragment";

const Highlighter = lazy(() => import("react-highlight-words"));

export const TextDefinition: React.FC<{
  filter?: string;
  definition: FragmentType<
    "Definition",
    { select: typeof TextDefinition_DefinitionFragment }
  >;
}> = ({ definition, filter }) => {
  return (
    <span>
      {definition.partOfSpeech && (
        <>
          <strong>{definition.partOfSpeech}.</strong>{" "}
        </>
      )}
      {filter ? (
        <Highlighter searchWords={[filter]} textToHighlight={definition.text} />
      ) : (
        definition.text
      )}
    </span>
  );
};
